import React from 'react';
import PropTypes from 'prop-types';
import {
  PageContentWrapper,
  CategoryHeadings,
  HeadingText,
  ContentBody,
  BoldText,
  PreformattedText,
} from '../../styled/searchResultPage';

export const KnowledgeBaseResultPage = ({ searchResult }) => {
  return (
    <PageContentWrapper>
      <CategoryHeadings>
        <HeadingText hide={!searchResult.heading}>
          <BoldText>Category:</BoldText> {searchResult.heading}
        </HeadingText>
        <HeadingText hide={!searchResult.category}>
          <BoldText>Category:</BoldText> {searchResult.category}
        </HeadingText>
        <HeadingText hide={!searchResult.fullSubheading}>
          <BoldText>Subcategory:</BoldText> <span>{searchResult.fullSubheading}</span>
        </HeadingText>
      </CategoryHeadings>
      <ContentBody>
        <PreformattedText>{searchResult.text}</PreformattedText>
      </ContentBody>
    </PageContentWrapper>
  );
};
export default KnowledgeBaseResultPage;

KnowledgeBaseResultPage.propTypes = {
  searchResult: PropTypes.object.isRequired,
};
